import { Injectable } from "@angular/core";
import { BaseHttpService } from "app/core/base-http.service";
import { urls } from "app/core/urls";
import { HttpUtils } from "app/models";
import { Observable } from "rxjs";
import {
  AutoSyncFilter,
  AutoSyncOperationModelResponse,
  AutoSyncOperationType,
  ShopifyUpdatedInventoryAdjustmentModel
} from "./auto-sync-history.component";

@Injectable()
export class AutoSyncHistoryService extends BaseHttpService {
  private httpUtils: HttpUtils = new HttpUtils();
  public getHistory(
    filter: AutoSyncFilter
  ): Observable<AutoSyncOperationModelResponse> {
    const request = this.toRequest(filter);
    //TODO: add normal pager
    var params = this.httpUtils.getParams(request);
    // const params: HttpParams = this.httpUtils.getParams({
    // 	...pager,
    // 	...request,
    // });

    //TODO: getAutoSyncHistoryUrl should return offset collection instead of object

    // this.http.get<AutoSyncOperationModelResponse>(urls.shopify.getAutoSyncHistoryUrl, {
    //     params: params,
    //     observe: "response",
    //   });
    // .pipe(
    //   map((resp) => {
    //     return this._httpUtils.toOffsetCollection<IOrderModel>(resp);
    //   })
    // );

    return this.get(urls.shopify.getAutoSyncHistoryUrl
      +"?page=" + filter.page + "&type="+ filter.type + "&keyword=" + encodeURIComponent(filter.keyword)
    );
  }

  public applyAutoSyncChanged(
    ids: number[]
  ): Observable<ShopifyUpdatedInventoryAdjustmentModel[]> {
    return this.post(urls.shopify.applyShopifyAutoSyncOperations, ids);
  }

  private toRequest(filter: AutoSyncFilter): AutoSyncRequest {
    const request: AutoSyncRequest = {
      page: filter.page,
      type: filter.type,
    };

    if (!!filter.keyword) {
      request.keyword = encodeURIComponent(filter.keyword);
    }

    return request;
  }
}
export interface AutoSyncRequest {
  type?: AutoSyncOperationType;
  page: number;
  keyword?: string;
}
